import { render, staticRenderFns } from "./ShanghaiClassSelector.vue?vue&type=template&id=6c3ef76a&scoped=true&"
import script from "./ShanghaiClassSelector.vue?vue&type=script&lang=js&"
export * from "./ShanghaiClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ef76a",
  null
  
)

export default component.exports